<template>
  <div>
    <ca-heading text="Cadastro de Horário/Turno" />

    <ca-page>
      <ca-loader v-if="showLoading"></ca-loader>

      <ca-form
        v-else
        :key="formKey"
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col size="6">
            <ca-field label="Código">
              <ca-input
                v-model="workShift.code"
                maxlength="30"
                required></ca-input>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Permitido flexibilidade dos horários">
              <ca-checkbox
                v-model="workShift.flexibleHours"
                label="Sim">
              </ca-checkbox>
            </ca-field>
          </ca-col>
        </ca-row>
        <ca-row>
          <ca-col>
            <ca-heading text="Jornada de trabalho" size="extra-small" />
          </ca-col>
        </ca-row>
        <ca-row>
          <ca-col size="6">
            <ca-field label="Horário de entrada">
              <ca-time-input
                v-model="workShift.checkInTime"
                required>
              </ca-time-input>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Horário de saída">
              <ca-time-input
                v-model="workShift.checkOutTime"
                required>
              </ca-time-input>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-row>
          <ca-col>
            <ca-heading text="Intervalo" size="extra-small" />
          </ca-col>
        </ca-row>

        <ca-row>
          <ca-col size="4">
            <ca-field label="Tipo de intervalo">
              <ca-select v-model="workShift.breakType.name" required>
                <ca-option
                  v-for="interval in misc.intervalTypes"
                  :key="interval.name"
                  :value="interval.name">
                  {{ interval.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>
          <ca-col
            v-if="isFixedInterval(intervalType)"
            size="4">
            <ca-field label="Horário inicial">
              <ca-time-input
                v-model="workShift.startOfBreak"
                required>
              </ca-time-input>
            </ca-field>
          </ca-col>
          <ca-col
            v-if="isFixedInterval(intervalType)"
            size="4">
            <ca-field label="Horário final">
              <ca-time-input
                v-model="workShift.endOfBreak"
                required>
              </ca-time-input>
            </ca-field>
          </ca-col>
          <ca-col
            v-if="isVariableInterval(intervalType)"
            size="4">
            <ca-field label="Duração">
              <ca-time-input
                v-model="workShift.breakDuration"
                required>
              </ca-time-input>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-row>
          <ca-col size="4">
            <ca-field label="Compartilhado">
              <ca-checkbox v-model="workShift.shared"></ca-checkbox>
            </ca-field>
          </ca-col>
        </ca-row>
        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <ca-submit-button>
                Salvar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { getBoxInformationErrorMessage, initFormObject } from 'packages/common/utils';
import {
  getWorkShift, createWorkShift, editWorkShift, isFixedInterval, isVariableInterval,
} from './workShiftService';

export default {
  name: 'WorkShiftsFormPage',
  data() {
    return {
      formKey: 0,
      workShiftId: this.$route.params.id,
      workShift: {
        ...initFormObject([{ esocialStatus: 'N' }, { breakType: 'F' }]),
        startOfBreak: null,
        endOfBreak: null,
        breakDuration: null,
      },
      errorMessage: null,
      showLoading: false,
    };
  },
  computed: {
    hasWorkShiftId() {
      return this.workShiftId;
    },
    misc() {
      return this.$store.state.misc;
    },
    intervalType() {
      return this.workShift.breakType.name;
    },
  },
  watch: {
    intervalType() {
      this.refreshForm();
    },
  },
  created() {
    this.initData();
  },
  methods: {
    isFixedInterval,
    isVariableInterval,
    initData() {
      this.$store.dispatch('misc/getIntervalTypes');

      if (this.hasWorkShiftId) {
        this.setWorkShift();
      }
    },
    async setWorkShift() {
      this.showLoading = true;
      try {
        this.workShift = await getWorkShift(this.workShiftId);
      } finally {
        this.showLoading = false;
      }
    },
    goBack() {
      this.$router.back();
    },
    onSubmit() {
      return this.hasWorkShiftId
        ? editWorkShift(this.workShiftId, this.workShift)
        : createWorkShift(this.workShift);
    },
    onSubmitSuccess() {
      this.goBack();
      this.$toaster.success('Dados salvos com sucesso');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
    refreshForm() {
      this.formKey++;
    },
  },
};
</script>
